import {useState} from 'react';

const OverlaySmiley = ({overlay}) => {
    const {contentParams} = overlay;
    const {smileys, theme, title} = contentParams;
    const [voted, setVoted] = useState(null);

    const onSmileyClick = (index) => {
        setVoted(smileys[index]);
        navigator.sendBeacon(smileys[index].callbackUrl);
        console.log(`Er is op smiley ${smileys[index].caption} geklikt`);
    };

    return !voted ? (
        <div className={`overlay-smiley overlay-smiley--${theme}`}>
            {title}
            <div className="overlay-smiley__smileys">
                {smileys.map((smiley, index) => {
                    return (
                        <button
                            key={index}
                            onClick={() => onSmileyClick(index)}
                            className="overlay-smiley__smiley"
                        >
                            {index === 0 ? '🙁' : index === 1 ? '😐' : '🙂'}
                            <div className="overlay-smiley__label">
                                {smiley.caption}
                            </div>
                        </button>
                    )
                })}
            </div>
        </div>
    ) : null;
}

export default OverlaySmiley
